import { get } from 'lodash';

import type { DashboardDataLink } from '../model/widget';

export type DataLinkValues = Record<string, string | string[]>;

export interface DataLinkContext {
  /** Data supplied by the widget, such as an OpenSearch document. */
  data?: unknown;
  /** Raw value of the selected cell or data point. */
  value?: unknown;
  /** Widget-specific data index, such as an OpenSearch index name. */
  index?: unknown;
  variables?: DataLinkValues;
}

const asVariableValue = (value: unknown): string | string[] | undefined => {
  if (['string', 'number', 'boolean'].includes(typeof value)) {
    return String(value);
  }
  if (
    Array.isArray(value) &&
    value.every((item) => ['string', 'number', 'boolean'].includes(typeof item))
  ) {
    return value.map(String);
  }
  return undefined;
};

export const resolveDataLinkValues = (
  link: DashboardDataLink,
  context: DataLinkContext,
): DataLinkValues => {
  const currentValues = context.variables ?? {};
  const values: DataLinkValues =
    link.includeCurrentVariables === false ? {} : { ...currentValues };

  for (const { name, source = 'field', field } of link.variables) {
    if (!name || ((source === 'field' || source === 'variable') && !field))
      continue;

    const raw = (() => {
      if (source === 'cell') return context.value;
      if (source === 'index') return context.index;
      if (source === 'variable') return currentValues[field];
      if (source === 'literal') return field;
      return get(context.data, field);
    })();
    const value = asVariableValue(raw);
    if (value !== undefined) values[name] = value;
  }

  return values;
};